<template>
  <svg width="6"
       height="8"
       viewBox="0 0 6 8"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.66667 6.91667C5.1269 6.91667 5.5 6.54357 5.5 6.08333C5.5 5.6231 5.1269 5.25 4.66667 5.25C4.20643 5.25 3.83333 5.6231 3.83333 6.08333C3.83333 6.54357 4.20643 6.91667 4.66667 6.91667Z"
      :stroke="color" />
    <path
      d="M1.33333 0.667318C0.873096 0.667318 0.5 1.04041 0.5 1.50065C0.5 1.96089 0.873096 2.33398 1.33333 2.33398C1.79357 2.33398 2.16667 1.96089 2.16667 1.50065C2.16667 1.04041 1.79357 0.667318 1.33333 0.667318Z"
      :stroke="color" />
    <path
      d="M1.33325 2.33398V4.41732C1.33325 5.20315 1.33325 5.59565 1.57742 5.83982C1.82159 6.08398 2.21409 6.08398 2.99992 6.08398H3.83325"
      :stroke="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
